import React from "react";
import Modal from "react-modal";
import { router } from "dva";
import Swiper from "swiper";

import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Row, Col, Form, Card, List, Typography, BackTop, Button } from "antd";
import { template, formatDate, setLocalStorage, transformImageUrl } from "@reco-m/core";
import { ViewComponent, mtaH5Click, statisticsEvent, TextAreaLength, Banner, Breadcrumbs, HtmlContent, ImageAuto, getParkCode } from "@reco-w/core-ui";

import { JudgeLogin } from "@reco-w/auth-common";
import { impressionModel, Namespaces } from "@reco-w/impression-models";

import { GDMap } from "./gd.map" ;

export namespace Impression {
    const { Paragraph } = Typography;

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> {}

    export interface IState extends ViewComponent.IState, impressionModel.StateType {}

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        namespace = Namespaces.impression;
        swiper: any;

        get parkCode() {
            return this.props.match!.params!.parkcode;
        }

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/impression`);
        }

        componentDidMount() {
            this.dispatch({
                type: "initPage",
                parkCode: this.parkCode || getParkCode(),
                callback: () => {
                    setTimeout(() => {
                        this.refSwiper();
                    }, 600);
                },
            });
        }

        /**
         * 渲染单条信息样式
         * @param title 标题
         * @param content 值
         * @param unit 单位
         * @param col 占格
         */
        renderParkInfoItem(title, content, unit?, col = 12): React.ReactNode {
            return (
                <Col span={col}>
                    <span className="type-name">{title}：</span>
                    {content ? `${content}${unit || ""}` : "--"}
                </Col>
            );
        }

        /**
         * 渲染园区地理位置
         */
        renderParkAdress(parkImpression) {
            return (
                <Col span={24}>
                    <span className="type-name">地理位置：</span>
                    {parkImpression?.address}
                    <em
                        onClick={() => {
                            window.open("about:blank")!.location.href = `https://www.amap.com/search?query=${parkImpression?.address}`; // 高德
                            mtaH5Click(statisticsEvent.viewParkMap);
                        }}
                        className="check-map"
                    >
                        <i className="icon iconmap1" />
                        查看地图
                    </em>
                </Col>
            );
        }

        /**
         * 渲染园区基本信息
         * @param parkImpression
         */
        renderParkInfo(parkImpression: any): React.ReactNode {
            return (
                <div className="impression-info">
                    <Row gutter={8}>
                        {this.renderParkInfoItem("总建筑面积(㎡)", parkImpression?.totalArea, "㎡")}
                        {this.renderParkInfoItem("公用面积", parkImpression?.publicArea, "㎡")}
                    </Row>
                    <Row gutter={8}>
                        {this.renderParkInfoItem("地上面积", parkImpression?.groundArea, "㎡")}
                        {this.renderParkInfoItem("地下面积", parkImpression?.undergroundArea, "㎡")}
                    </Row>
                    <Row gutter={8}>
                        {this.renderParkInfoItem("绿化面积", parkImpression?.greenArea, "㎡")}
                        {this.renderParkInfoItem("绿化率", parkImpression?.greeningRate, "%")}
                    </Row>
                    <Row gutter={8}>
                        {this.renderParkInfoItem("规划容积率", parkImpression?.planningFloorAreaRatio, "%")}
                        {this.renderParkInfoItem("实际容积率", parkImpression?.realFloorAreaRatio, "%")}
                    </Row>
                    <Row gutter={8}>
                        {this.renderParkInfoItem("得房率", parkImpression?.houseEfficientRate, "%")}
                        {this.renderParkInfoItem("停车位", parkImpression?.parkingSpaceCount, "个")}
                    </Row>
                    <Row gutter={8}>
                        {this.renderParkInfoItem("竣工时间", formatDate(parkImpression?.endBuildTime || "", "yyyy年MM月dd日"))}
                        {this.renderParkInfoItem("投资商", parkImpression?.investor)}
                    </Row>
                    <Row gutter={8}>{this.renderParkAdress(parkImpression)}</Row>
                </div>
            );
        }

        /**
         * 渲染联系信息
         * @param parkImpression
         */
        renderContact(parkImpression: any): React.ReactNode {
            return (
                <div className="impression-info">
                    <Row gutter={8}>
                        {this.renderParkInfoItem("联系人", parkImpression?.contactPerson)}
                        {this.renderParkInfoItem("联系电话", parkImpression?.contactPhonenumber)}
                    </Row>
                    <Row gutter={8}>{this.renderParkInfoItem("联系地址", parkImpression?.address, null, 24)}</Row>
                </div>
            );
        }

        /**
         * 点击图片
         * @param item
         * @param i
         */
        onImageClick(item, i) {
            this.dispatch({ type: "input", data: { open: true, file: item } });
            setTimeout(() => {
                this.swiperSlider(i);
            });
            $(document).keydown((event) => {
                if (event.keyCode === 27) {
                    this.dispatch({ type: "input", data: { open: false } });
                }
            });
        }

        /**
         * 取消图片
         */
        onCancel() {
            this.dispatch({ type: "input", data: { open: false } });
        }

        onClick() {
            if (!this.isAuth()) {
                this.dispatch({ type: "input", data: { isShowModal: true } });
            } else {
                mtaH5Click(statisticsEvent.bookingRoom);
                const { state } = this.props,
                    checking = state!.checking;
                this.goTo(`/${getParkCode()}/workorder/yykf?KFXQ=${checking || ""}`);
            }
        }

        renderJudgeLogin() {
            return this.renderEmbeddedView(JudgeLogin.Page as any, {
                isShowModal: this.state?.isShowModal,
                onSuccess: () => {
                    this.dispatch({ type: "input", data: { isShowModal: false } });
                },
                onClose: () => {
                    this.dispatch({ type: "input", data: { isShowModal: false } });
                },
            });
        }

        /**
         * 渲染看房需求
         */
        renderForm(): React.ReactNode {
            const { state } = this.props,
                checking = state!.checking;

            return (
                <Form className="contact-form">
                    <Form.Item>
                        <TextAreaLength.Component
                            showLength={true}
                            maxLength={500}
                            value={checking}
                            onChange={(e) => {
                                this.dispatch({ type: "input", data: { checking: e.target.value } });
                            }}
                            rows={4}
                            placeholder="请输入看房需求"
                        />
                    </Form.Item>
                    <Form.Item>
                        <div className="blank16" />
                        <div className="policy-tips">提交后客服会尽快与您联系，谢谢！</div>
                        <div className="blank11" />
                        <Button onClick={() => this.onClick()} className="login-form-button" type="primary">
                            预约看房
                        </Button>
                        <div className="policy-phone">
                            <i className="icon icondianhua" />
                            {client.tel}
                        </div>
                    </Form.Item>
                </Form>
            );
        }

        swiperSlider(i) {
            this.swiper = new Swiper(".img-view", {
                initialSlide: i,
                zoom: true,
                slidesPerView: "auto",
                pagination: {
                    el: ".swiper-pagination",
                    type: "bullets",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        }

        /**
         * 渲染其他园区
         */
        renderOtherPark(): React.ReactNode {
            const { state } = this.props,
                parkName = state!.parkName;
            return (
                <List
                    className="list-basic"
                    itemLayout="horizontal"
                    dataSource={parkName}
                    renderItem={(item: any, i) => (
                        <List.Item key={i} className="padding-top-0 padding-bottom-0">
                            <List.Item.Meta
                                title={
                                    <Paragraph ellipsis>
                                        <i className="bg-color2">{i + 1}</i>
                                        <router.Link
                                            target="_blank"
                                            to={`/${item.code}/impression`}
                                            onClick={() => {
                                                mtaH5Click(statisticsEvent.browseOtherParks);
                                            }}
                                        >
                                            <span className="size-14">{item.title}</span>
                                        </router.Link>
                                    </Paragraph>
                                }
                            />
                        </List.Item>
                    )}
                />
            );
        }

        /**
         * 导航栏
         */
        renderPath(): React.ReactNode {
            const breadcrumbList = [
                { router: "", name: "园区招商" }
            ];

            return <Breadcrumbs.Component breadcrumbList={breadcrumbList} />;
        }

        /**
         * 渲染园区图片
         */
        refSwiper() {
            this.swiper = new Swiper("#img-list", {
                slidesPerView: 5,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev",
                },
            });
        }

        renderParkImage(): React.ReactNode {
            const { state } = this.props,
                parkPictureAsync = state!.parkPictureAsync;
            return (
                <div className="swiper-list-next ml16">
                    <div className="swiper-next">
                        <RightOutlined />
                    </div>
                    <div className="swiper-prev">
                        <LeftOutlined />
                    </div>
                    <div className="swiper-container " id="img-list">
                        <div className="swiper-wrapper">
                            {parkPictureAsync?.map((item: any, i: any) => (
                                <div key={i} className="swiper-slide hand" onClick={() => this.onImageClick(item, i)}>
                                    <ImageAuto.Component cutWidth="150" cutHeight="110" alt="" src={item} width="150px" height="110px"></ImageAuto.Component>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        }

        /**
         * 渲染园区页面
         */
        renderContentDetail(): React.ReactNode {
            const { state } = this.props,
                isShowMap = state!.isShowMap,
                parkImpression = state!.parkImpressionDetailData;
                console.log('parkImpressionparkImpressionparkImpression' , isShowMap);
                
            return (
                <div className="container">
                    {this.renderPath()}
                    <Row gutter={16}>
                        <Col className="gutter-row" span={17}>
                            <Card title={<div>{parkImpression?.shortName}</div>} className="details-content">
                                {this.renderParkInfo(parkImpression)}
                            </Card>
                            <div className="blank16" />
                            <Card title={"联系信息"} className="details-content">
                                {this.renderContact(parkImpression)}
                            </Card>
                            <div className="blank16" />
                            <Card title={"园区图片"} className="details-content">
                                {this.renderParkImage()}
                            </Card>
                            <div className="blank16" />
                            <Card title={"园区简介"} className="details-content">
                                <div className="details-content-write">
                                    <HtmlContent.Component html={parkImpression?.summary} />
                                </div>
                            </Card>
                            <div className="blank16" />
                            {parkImpression?.address && isShowMap && (
                                <Card title={"园区地图"} className="details-content">
                                    <div className="impression-map">{<GDMap.Component title={"园区位置"} address={parkImpression?.address} mapStyle={""} titleStyle={""} />}</div>
                                </Card>
                            )}
                        </Col>
                        <Col className="gutter-row" span={7}>
                            {/* <Card title={<div className="hot-title">其他园区</div>} className="popular-content">
                                {this.renderOtherPark()}
                            </Card> */}
                            {/* <div className="blank16" /> */}
                            <Card title={<div className="hot-title">看房需求</div>} className="popular-content">
                                {this.renderForm()}
                            </Card>
                        </Col>
                    </Row>
                    <div className="blank16" />
                </div>
            );
        }

        /**
         * 渲染整屏图片
         */
        renderSwiperImage(): React.ReactNode {
            const { state } = this.props,
                open = state!.open,
                parkPictureAsync = state!.parkPictureAsync;
            return (
                <Modal
                    ariaHideApp={false}
                    style={{
                        overlay: {
                            backgroundColor: "rgba(0,0,0,1)",
                        },
                        content: {
                            backgroundColor: "transparent",
                            border: "none",
                            overflow: "initial",
                            display: "flex",
                            alignItems: "center",
                            padding: "0",
                            top: "0",
                            left: "0",
                            bottom: "0",
                            right: "0",
                            zIndex: 999,
                        },
                    }}
                    closeTimeoutMS={500}
                    isOpen={open}
                    onRequestClose={() => this.onCancel()}
                >
                    <div className="ant-modal-close ant-modal-close-x" onClick={() => this.onCancel()}>
                        {/* <Icon type="close" className="white-color" /> */}
                    </div>
                    <div className="swiper-container img-view">
                        <div className="swiper-wrapper">
                            {parkPictureAsync &&
                                parkPictureAsync.length > 0 &&
                                parkPictureAsync.map((item: any, i: any) => (
                                    <div className="swiper-slide" key={i}>
                                        <div className="swiper-zoom-container">
                                            <img src={transformImageUrl(item, 200, 200)} />
                                        </div>
                                    </div>
                                ))}
                        </div>
                        <div className="swiper-pagination" />
                        <div className="swiper-button-prev  swiper-button-white" />
                        <div className="swiper-button-next  swiper-button-white" />
                    </div>
                </Modal>
            );
        }

        renderBody(): React.ReactNode {
            return (
                <>
                    <div className="content details-html">
                        <Banner.Component bimg="assets/images/banner/quanzi.png" cimg="assets/images/banner/quanzi_txt.png"></Banner.Component>
                        {this.renderContentDetail()}
                    </div>
                    <div className="scoll-top">
                        <BackTop visibilityHeight={50} />
                    </div>
                    {this.renderSwiperImage()}
                    {this.renderJudgeLogin()}
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.impression]);
}
